import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && url.startsWith("/admin") && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("admin_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

let imgVersion = 2;
export const setImgVersion = (v) => (imgVersion = v);
export const thumbUrl = (id) => `${API}/photos/${id}/thumb?v=${imgVersion}`;
export const previewUrl = (id) => `${API}/photos/${id}/preview?v=${imgVersion}`;
export const downloadUrl = (session, id) => `${API}/orders/${session}/download/${id}`;
export const downloadAllUrl = (session) => `${API}/orders/${session}/download-all`;

export const brl = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const fmtDate = (d) => {
  if (!d) return "";
  const [y, m, day] = d.slice(0, 10).split("-");
  return `${day}/${m}/${y}`;
};

export const CATEGORIES = {
  surf: "Surf / Body Board",
  lifestyle: "Life Style",
  bike: "Bike",
  corrida: "Corrida",
  triathlon: "Triathlon",
  festa: "Festa",
  outros: "Outros",
};

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
